// Пул голосов озвучки владельца (docs/VOICES.md): свои голоса Gemini (voice design на gemini-3.8-flash-tts),
// быстрые и динамичные, узбекский. Голос живёт в проекте Google того ключа, которым создан: эти видит ключ
// gemini_api платформы. Имя — в матрице, паспорте ролика и инструменте tts; в запрос к Gemini уходит id (voiceId).
// Без zod: пул читает и интерфейс.

export type VoiceGender = 'f' | 'm';

/** Голоса пула: имя → id своего голоса и пол. Готовые голоса Google (Leda, Orus…) больше не используются. */
export const VOICES = {
  Jasur: { id: 'voice_pd4gvimq9a26', gender: 'm' },
  Sardor: { id: 'voice_peatcbtn9sgb', gender: 'm' },
  Bekzod: { id: 'voice_ckwizz3os33r', gender: 'm' },
  Rustam: { id: 'voice_0fgd0vkmpn8f', gender: 'm' },
  Otabek: { id: 'voice_xjg5noxhtsci', gender: 'm' },
  Malika: { id: 'voice_atoqlsi7ubwj', gender: 'f' },
  Dilnoza: { id: 'voice_u63qp07vofly', gender: 'f' },
  Zarina: { id: 'voice_sk0lap6qfegm', gender: 'f' },
  Gulnora: { id: 'voice_3ucozv4xg9vj', gender: 'f' },
  Shahnoza: { id: 'voice_xi9vqt27zzxv', gender: 'f' },
} as const satisfies Record<string, { id: `voice_${string}`; gender: VoiceGender }>;

export type VoiceName = keyof typeof VOICES;
export const ALL_VOICES: readonly string[] = Object.keys(VOICES);

const pool: Record<string, { id: string; gender: VoiceGender } | undefined> = VOICES;

/** Голоса пула одного пола. */
export const voicesOf = (gender: VoiceGender): string[] =>
  ALL_VOICES.filter((v) => pool[v]?.gender === gender);

/** Пол голоса пула; не из пула — null. */
export const voiceGenderOf = (name: string): VoiceGender | null => pool[name]?.gender ?? null;

/** id своего голоса для запроса к Gemini; имя не из пула — как есть (готовый голос в заданиях до перехода). */
export const voiceId = (name: string): string => pool[name]?.id ?? name;
